import { render, staticRenderFns } from "./BalanceItem.vue?vue&type=template&id=f0fc53fe&scoped=true"
import script from "./BalanceItem.vue?vue&type=script&lang=js"
export * from "./BalanceItem.vue?vue&type=script&lang=js"
import style0 from "./BalanceItem.vue?vue&type=style&index=0&id=f0fc53fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fc53fe",
  null
  
)

export default component.exports